import { Step, StepIndicator, Stepper } from "@mui/joy";

interface StepperProgressProps {
	page: number;
}

export function ImportProgress(props: StepperProgressProps) {
	return (
		<Stepper className="w-full">
			<ImportStep number={1} active={props.page == 1} label="Info" />
			<ImportStep number={2} active={props.page == 2} label="Credentials" />
			<ImportStep number={3} active={props.page == 3} label="Data selection" />
			<ImportStep number={4} active={props.page == 4} label="Import" last />
		</Stepper>
	);
}

interface ImportStepProps {
	number: number;
	label: string;
	active: boolean;
	last?: boolean;
}

function ImportStep(props: ImportStepProps) {
	return (
		<Step
			orientation="vertical"
			data-last-child={props.last ? "" : null}
			indicator={
				<StepIndicator variant={props.active ? "solid" : "outlined"} color={props.active ? "primary" : "neutral"}>
					{props.number}
				</StepIndicator>
			}
		>
			{props.label}
		</Step>
	);
}
